import React, { useEffect, useState } from 'react'
import { useAppData } from '../../../../../context/AppDataContext'

function CategoryTransactionAnalytics({transactionItemList}) {

    const {transactionCategoryDD} = useAppData();

    const [categoryData,setVendorData] = useState(null)

    const prepareData = () =>{
        let _data =[];
        transactionCategoryDD.forEach((v,i)=>{
            _data[i] = v;
            _data[i].amount = 0;
            transactionItemList.forEach(t => {
                if(t.payeeType == 2 && t.transactionCategory == _data[i].value) {
                    _data[i].amount = Number(_data[i].amount+t.amount)
                }
            });
        })
        setVendorData(_data);
    }

    useEffect(()=>{
        if(transactionItemList){
            prepareData()
        }
    },[transactionItemList])

    const calculateTotal = () => {
        return categoryData.reduce((accumulator, currentObject) => {
            // We use Number() to ensure we don't accidentally concatenate strings
            return accumulator + Number(currentObject.amount || 0);
        }, 0);
    };

    return (
        categoryData &&
        <table className='table table-bordered table-striped'>
            <thead>
                <tr>
                    <th  colSpan={2} className='text-center table-dark'>Category Payment</th>
                </tr>
                <tr>
                    <th>Category</th>
                    <th>Amount</th>
                </tr>
            </thead>
            <tbody>
                {categoryData.map(category=>
                    category.amount > 0 &&
                    <tr key={category.value}>
                        <td>{category.label}</td>
                        <td>{category.amount}</td>
                    </tr>
                )}
            </tbody>
            <tfoot>
                <tr>
                    <th>Total</th>
                    <th>{calculateTotal()}</th>
                </tr>
            </tfoot>
        </table>
    )
}

export default CategoryTransactionAnalytics